import React from 'react';

import Tabs, { Tab } from '../../../tabs/tabs';

import './fitment-sub-tabs.redesign.scss';

export interface TabProps {
  description: string;
  id: string;
}

interface FitmentSubTabsProps {
  children?: React.ReactNode;
  onTabSelected?: (tab: TabProps) => void;
  selectedTab?: TabProps;
  tabs: TabProps[];
}

function FitmentSubTabs(props: FitmentSubTabsProps) {
  const { children, onTabSelected, selectedTab, tabs } = props;

  return (
    <div>
      <Tabs isSecondary styleName="tabs">
        {tabs?.map(tab => {
          const isSelected = selectedTab?.id === tab.id;

          return (
            <Tab
              isSelected={isSelected}
              key={tab.description}
              onClick={() => {
                if (!isSelected) {
                  onTabSelected?.(tab);
                }
              }}
              styleName={!isSelected ? 'tab' : 'tab-selected'}
            >
              {tab.description}
            </Tab>
          );
        })}
      </Tabs>
      {children}
    </div>
  );
}

export default FitmentSubTabs;
